module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('content-loader', {
    attrs: {
      "height": 560,
      "width": 760,
      "speed": 2,
      "primaryColor": "#f3f3f3",
      "secondaryColor": "#ecebeb"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "251.1",
      "cy": "143.1",
      "r": "62.1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "431.1",
      "cy": "143.1",
      "r": "62.1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "611.1",
      "cy": "141.1",
      "r": "62.1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "248.1",
      "cy": "281.1",
      "r": "62.1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "430.1",
      "cy": "281.1",
      "r": "62.1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "608.1",
      "cy": "281.1",
      "r": "62.1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "248.1",
      "cy": "425.1",
      "r": "62.1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "428.1",
      "cy": "422.1",
      "r": "62.1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "607.1",
      "cy": "421.1",
      "r": "62.1"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "196.56",
      "y": "46.61",
      "rx": "0",
      "ry": "0",
      "width": "107",
      "height": "14.96"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "376.56",
      "y": "43.61",
      "rx": "0",
      "ry": "0",
      "width": "107",
      "height": "14.96"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "555.56",
      "y": "42.61",
      "rx": "0",
      "ry": "0",
      "width": "107",
      "height": "14.96"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "113.56",
      "y": "89.61",
      "rx": "0",
      "ry": "0",
      "width": "16.05",
      "height": "97.9"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "113.56",
      "y": "249.61",
      "rx": "0",
      "ry": "0",
      "width": "14.98",
      "height": "72.16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "113.56",
      "y": "391.61",
      "rx": "0",
      "ry": "0",
      "width": "14.98",
      "height": "72.16"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f7e7f1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/common/content-loaders/AudienceProfileLoader.vue
// module id = 3172
// module chunks = 3